import React from "react";
import { CloudOutlined, SyncOutlined } from "@ant-design/icons";
import { Text, Tooltip } from "../../components";
import styled from "styled-components";
import { themeProp } from "../../theme";
import { useString as s } from "../StringProvider";
import { useCuvamaDiscoveryLink } from "../../providers/cuvamaDiscoveryLinkProvider";
import { useLastSyncFormat } from "../../utils/formatting";

const SyncStatusIndicator = () => {
  const { cuvamaDiscoveryLink } = useCuvamaDiscoveryLink();

  const syncingTooltip = s(
    "discovery.header.sync.inProgress",
    "Syncing to Discovery Report..."
  );
  const lastSyncDate = useLastSyncFormat(
    cuvamaDiscoveryLink?.syncedAt ?? new Date()
  );
  const changesText = s(
    "discovery.header.sync.changesText",
    "Changes in Value Case automatically sync with Discovery Report"
  );
  const lastSyncText = s(
    "discovery.header.sync.lastSyncText",
    "Last sync: {lastSyncDate}",
    { lastSyncDate }
  );

  const syncedText = s("discovery.header.sync.complete", "Discovery is synced");

  const syncedTooltip = () => (
    <ToolTipDiv>
      <Text variant={"small"} color={"#fff"} alignment={"left"}>
        {changesText}
      </Text>
      <Text variant={"small"} color={"text"} alignment={"left"}>
        {lastSyncText}
      </Text>
    </ToolTipDiv>
  );

  if (!cuvamaDiscoveryLink) {
    return null;
  }

  const { syncInProgress } = cuvamaDiscoveryLink;

  return (
    <Tooltip
      title={syncInProgress ? syncingTooltip : syncedTooltip}
      overlayStyle={{ maxWidth: 280 }}
      overlayInnerStyle={{ maxWidth: 280 }}
    >
      <IconWrapper data-cy="sync-status-indicator">
        {syncInProgress ? (
          <SyncOutlined spin style={{ fontSize: 16 }} />
        ) : (
          <CloudOutlined style={{ fontSize: 16 }} />
        )}
        <Text variant={"small"}>{syncedText}</Text>
      </IconWrapper>
    </Tooltip>
  );
};

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${themeProp("palette.gray3")};
  cursor: default;
  gap: 8px;
  padding-left: 8px;

  & > span {
    white-space: nowrap;
  }
  
  & > span:last-child {
    color: ${themeProp("palette.gray4")};
  }
  
`;

const ToolTipDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  
  & span {
    color: #fff;
    text-align: left !important;
  }

  & span:last-child {
    opacity: 0.6;
  }
`;

export default SyncStatusIndicator;
